import { FC } from "react";

import type { ITextAreaProps } from "@dzambalaorg/mui-inputs-core";

import { TextInput } from "../text";

export const TextAreaInput: FC<ITextAreaProps> = props => {
  return <TextInput multiline minRows={5} maxRows={Infinity} {...props} />;
};
